import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import { Select } from 'components';
import { NATIONALITY_OPTIONS } from './constants';
import { POB_OPTIONS } from '../Step1/constants';
import { useLang } from '../PlayerRegistration';
import './style.scss';

export const Step9 = () => {
  const { t } = useLang();

  return (
    <Layout className="player-registration__step-9">
      <Row className="step-header">
        <Col span={24}>
          <Typography.Title level={4}>{t('subtitle_step_9')}</Typography.Title>
        </Col>
        <Col span={24}>
          <Typography.Text>{t('description_step_9')}</Typography.Text>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col span={24} md={{ span: 12 }}>
          <Select
            name="ethnicity"
            label={t('label_ethnicity')}
            options={NATIONALITY_OPTIONS}
            rules={[{ required: true, message: t('error_ethnicity') }]}
          />
        </Col>
        <Col span={24} md={{ span: 12 }}>
          <Select
            name="nationality"
            label={t('label_nationality')}
            options={POB_OPTIONS}
            rules={[{ required: true, message: t('error_nationality') }]}
          />
        </Col>
      </Row>
    </Layout>
  );
};
